import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-followupnotrequired',
  templateUrl: './followupnotrequired.component.html',
  styleUrls: ['./followupnotrequired.component.scss']
})
export class FollowupnotrequiredComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
